exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".p-hdg-bottomline[data-v-dbd1baa2]{margin-top:0}.v-allergy-list-block+.v-allergy-list-block[data-v-dbd1baa2]{margin-top:55px}@media (max-width: 47.99em){.v-allergy-list-block+.v-allergy-list-block[data-v-dbd1baa2]{margin-top:28px}}\n", ""]);
